import { render, staticRenderFns } from "./subject_matter_delivery.vue?vue&type=template&id=6ff3934d"
import script from "./subject_matter_delivery.vue?vue&type=script&lang=js"
export * from "./subject_matter_delivery.vue?vue&type=script&lang=js"
import style0 from "./subject_matter_delivery.vue?vue&type=style&index=0&id=6ff3934d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports